import { render, staticRenderFns } from "./IconMicrosoft.vue?vue&type=template&id=602e74f8&"
import script from "./IconMicrosoft.vue?vue&type=script&lang=ts&"
export * from "./IconMicrosoft.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports